import React, { useMemo } from 'react'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { v4 } from 'uuid'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { useFormContext, Controller } from 'react-hook-form'

import cx from 'classnames'
import { useFlowContext } from '../../../../contexts'
import { createStep } from 'Actions/flow'

function getSelectedStep(stepId, flow) {
  const selectedStep = _.get(flow, `steps.${stepId}`)

  if (!selectedStep) {
    return null
  }

  const selectedStepName = selectedStep.name

  return {
    label: selectedStepName,
    value: stepId
  }
}

const Step = ({ allowStepCreate, actionGroup, className, name = 'action' }) => {
  const flow = useFlowContext()
  const dispatch = useDispatch()
  const {
    control,
    setValue,
    formState: { errors }
  } = useFormContext()

  const options = useMemo(
    () =>
      (() => {
        const choices = []

        _.forIn(flow.steps, (step, stepId) => {
          const isStartingStep = flow.starting_step_id === stepId
          const label = isStartingStep ? "Bot's first step" : step.name

          choices.push({
            label,
            value: stepId
          })
        })
        return choices
      })(),
    [flow]
  )

  const SelectComponent = allowStepCreate ? CreatableSelect : Select
  const actionFormPath = `${name}.${actionGroup ? actionGroup + '.' : ''}step`

  const handleStepCreation = (text) => {
    const stepId = v4()

    const stepName = text
    const internalName = _.kebabCase(text)

    dispatch(
      createStep({
        stepId,
        stepName,
        internalName
      })
    )

    setValue(actionFormPath, stepId)
  }

  const stepError = _.get(errors, actionFormPath)
  return (
    <div className='select-action'>
      <div className='label'>What is the next step?</div>
      <Controller
        name={actionFormPath}
        control={control}
        shouldUnregister
        rules={{
          required: {
            value: true,
            message: 'Step is required'
          }
        }}
        render={({ field: { value, onChange } }) => {
          return (
            <SelectComponent
              menuPlacement='auto'
              menuPortalTarget={document.body}
              menuPosition='fixed'
              options={options}
              className={cx({ 'is-invalid': stepError })}
              classNamePrefix={`${className} react_select`}
              onCreateOption={handleStepCreation}
              value={getSelectedStep(value, flow)}
              onChange={(option) => {
                onChange(option.value)
              }}
            />
          )
        }}
      />
      {allowStepCreate && <small className='form-text text-muted mb-2'>Type a new step name to create a step</small>}
      {stepError && <small className='form-text text-danger'>{stepError.message}</small>}
    </div>
  )
}

export default Step
